export {
  MOBILE_SCREEN_SIZE,
  TABLET_SCREEN_SIZE,
  SMALL_TABLET_SCREEN_SIZE,
  SMALL_MOBILE_SCREEN_SIZE,
} from "@brandclub/common-ui";

export const DRAWER_Z_INDEX = 1200;
export const MOBILE_TOP_BAR_HEIGHT = 70;
export const DESKTOP_TOP_BAR_HEIGHT = 80;
export const NAV_BAR_HEIGHT = 135;

export type SingleNavType = {
  name: string;
  displayName: string;
  route?: string;
  subNav?: SingleNavType[];
  previewImageUrl?: string;
  metaDescription?: string;
};
